import styles from './ServiceElections.module.css'

const ServiceElections = () => (
  <>
    <header className={styles.header}>
      <div className={styles.contentContainer}></div>
    </header>
  </>
)

export default ServiceElections
